import {Button, FormControl, FormLabel, MenuItem, Select, type SelectChangeEvent, Stack} from "@mui/material";
import {BackLink} from "@/global/components/BackLink";
import type {StudentsAiSchoolDto} from "@/global/api/gen/ts/StudentsAiSchoolDto";

interface Props {
    returnFirstStep: () => void,
    handleStudentSelect: (event: SelectChangeEvent) => void;
    studentInfo: StudentsAiSchoolDto;
    handlePickStudent: () => void;
}

export function SchoolPickStep({returnFirstStep, studentInfo, handlePickStudent, handleStudentSelect}: Props) {
    return (
        <Stack
            width={{lg: '60%', xs: '100%'}}
            flexDirection={'column'}
            gap={2}
            sx={{
                margin: '0 auto',
                p: 4,
                borderRadius: '26px',
                background: '#F5F5F5',
                gap: '16px'
            }}
        >
            <BackLink
                label={'Вернуться к вводу ИИН'}
                onClick={returnFirstStep}
                sx={{
                    alignSelf: 'flex-start'
                }}
            />
            <FormControl fullWidth>
                <FormLabel
                    sx={{
                        mb: 2
                    }}
                >
                    Выбор школы
                </FormLabel>
                <Select
                    onChange={handleStudentSelect}
                    displayEmpty
                >
                    {studentInfo.students.map((value) => {
                        const group = value.group;
                        const school = value.group?.school;
                        if (!school || !group) {
                            return null;
                        }
                        return (
                            <MenuItem
                                value={value.id}
                                key={group.id}
                            >
                                {`Школа ${school.title}, Группа ${group.title}, Категория ${group.category_id ?? ''}`}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
            <Button
                onClick={handlePickStudent}
            >
                Далее
            </Button>
        </Stack>
    );
}